import { JackpotLevel, JackpotValue2 } from "./api";
import { GetOrientation, Orientation } from "./FitScreen";
import { ISkeletonData, ITrackEntry, Spine } from "pixi-spine";
// import { JackpotLevel, JackpotValue2 } from "./api";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { Resourceful, Resourceful2 } from "./ResourceManager/Resourceful";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import * as PIXI from 'pixi.js'
import { JPContainerProps, JPFrameProps } from "./JackpotDisplayResponsive";
import { JackPotTextParams } from "./JackPotTextParams";
import { Log, LogGroup, Safe, Scale, shuffle, Size } from "./MyHelpers";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { JackpotDisplayProperties } from "./JackpotDisplayProperties";
import { Settings } from "./Settings";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { IRandomTimeout } from "./Context/RandomTimeout";
import { ISystemContext } from "./Context/SystemContext";
import { ScreenProtocolScope, ScreenProtocol } from "./ScreenProtocol";
import { FixedSizeFitContainer, ResponsiveSizeContainer, ResponsiveView } from "../singlegame/ResponsiveHelpers";
import { DecodedImageResource } from "./ResourceManager/ImageResource";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { he } from "date-fns/locale";
import { GameViewAppPixiResponsive } from "./engine/gameViewAppPixiResponsive";
import { JSONResource } from "./ResourceManager/JSONResource";
import { AtlasResource } from "./ResourceManager/AtlasResource";
import { PixiSpriteResource } from "./ResourceManager/PixiSpriteResource";
import { PixiSprite } from "./slot/Sprite/PixiSprite";

// export interface IJackpotDisplay extends Resourceful
// {
// 	StartAnimations(): void;
// 	StopAnimations(): void;
// 	View(): HTMLElement;
// 	Update(): void;
// 	UpdateValues(jackpotValues: JackpotValue2[]): void;
// 	TitleHide();
// 	TitleShow();	
// 	Pause();
// 	Resume();
// 	Reset(jpLevel? : JackpotLevel);

// }
export interface JpAnimationSpine {
	spine: Spine,
	animation: string[];
}


export const MainContainerSize =
{
	width: 1920,
	height: 1080,
};

const FixPosition =
{
	jp4x: 1500,
	jp3x: 1500,
	jp2x: 100,
	jp1x: 100,
	titlex: 100,
	x: 100,
}
export const frameProps: Record<JackpotLevel, JPFrameProps> = {
	[JackpotLevel.Jp4]: {
		containerWidth: 798,
		containerHeight: 197,

		backgroundX: 0,
		backgroundY: 0,
		backgroundWidth: 798,
		backgroundHeight: 197,

		textX: 253,
		textY: 70,
		textWidth: 485,
		textHeight: 75,
	},
	[JackpotLevel.Jp3]: {
		containerWidth: 798,
		containerHeight: 197,

		backgroundX: 0,
		backgroundY: 0,
		backgroundWidth: 798,
		backgroundHeight: 197,

		textX: 257,
		textY: 62,
		textWidth: 449,
		textHeight: 88,
	},
	[JackpotLevel.Jp2]: {
		containerWidth: 733,
		containerHeight: 197,

		backgroundX: 0,
		backgroundY: 0,
		backgroundWidth: 733,
		backgroundHeight: 197,

		textX: 254,
		textY: 61,
		textWidth: 413,
		textHeight: 89,
	},
	[JackpotLevel.Jp1]: {
		containerWidth: 733,
		containerHeight: 197,

		backgroundX: 0,
		backgroundY: 0,
		backgroundWidth: 733,
		backgroundHeight: 197,

		textX: 254,
		textY: 61,
		textWidth: 413,
		textHeight: 89,
	},
	[JackpotLevel.Jp4s]: {
		containerWidth: 0,
		containerHeight: 0,

		backgroundX: 0,
		backgroundY: 0,
		backgroundWidth: 0,
		backgroundHeight: 0,

		textX: 0,
		textY: 0,
		textWidth: 0,
		textHeight: 0,
	},
	[JackpotLevel.Jp3s]: {
		containerWidth: 0,
		containerHeight: 0,

		backgroundX: 0,
		backgroundY: 0,
		backgroundWidth: 0,
		backgroundHeight: 0,

		textX: 0,
		textY: 0,
		textWidth: 0,
		textHeight: 0,
	}
};

// export const containerProps: Record<Orientation, Record<JackpotLevel, JPContainerProps>> = {
// 	[Orientation.Portrait]: {
// 		[JackpotLevel.Jp4]: {
// 			width: 532,
// 			height: 104
// 		},
// 		[JackpotLevel.Jp3]: {
// 			width: 383,
// 			height: 135
// 		},
// 		[JackpotLevel.Jp2]: {
// 			width: 360,
// 			height: 128
// 		},
// 		[JackpotLevel.Jp1]: {
// 			width: 343,
// 			height: 128
// 		},
// 		[JackpotLevel.Jp4s]: {
// 			width: 0,
// 			height: 0
// 		},
// 		[JackpotLevel.Jp3s]: {
// 			width: 0,
// 			height: 0
// 		}
// 	},
// 	[Orientation.Landscape]: {
// 		[JackpotLevel.Jp4]: {
// 			width: 532,
// 			height: 104
// 		},
// 		[JackpotLevel.Jp3]: {
// 			width: 383,
// 			height: 135
// 		},
// 		[JackpotLevel.Jp2]: {
// 			width: 360,
// 			height: 128
// 		},
// 		[JackpotLevel.Jp1]: {
// 			width: 343,
// 			height: 128
// 		},
// 		[JackpotLevel.Jp4s]: {
// 			width: 0,
// 			height: 0
// 		},
// 		[JackpotLevel.Jp3s]: {
// 			width: 0,
// 			height: 0
// 		}
// 	}
// };

//missing convert for abstract class 
export abstract class IJackpotDisplayResponsive extends IJackpotDisplay implements Resourceful2 {

	// protected jp1text: JackpotText = null;
	// protected jp2text: JackpotText = null;
	// protected jp3text: JackpotText = null;
	// protected jp4text: JackpotText = null;
	protected view: HTMLElement = null;
	protected viewSize: Size = null;
	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;
	protected screenProtocolScope: ScreenProtocolScope = null;
	protected screenProtocol: ScreenProtocol = null;
	protected systemContext: ISystemContext = null;
	protected inLineJackpotContainer: PIXI.Container = null;
	protected titleJackpotSkeletonData: ISkeletonData = null;
	protected gameName: string = null
	protected gameSpriteResource: PixiSpriteResource = null;
	protected gameSprite: DecodedImageResource = null;
	protected gameTitleSprite: PIXI.Sprite = null;

	public constructor(params: JackpotDisplayParams) {
		super(params);
		this.jackpot = Settings.ResourcesFolder + `multigame/multigame/img/`;
		if (params.gameName) {
			this.gameName = params.gameName;
			this.basepath = Settings.ResourcesFolder + "multigame/slot/" + params.gameName + "/resources/";
		}
		this.jackpotName = Settings.JackpotDisplayType;
		if (JackpotDisplayProperties[Settings.JackpotDisplayType].alias) {
			this.jackpotName = JackpotDisplayProperties[Settings.JackpotDisplayType].alias;
		}

	}


	protected overridejackpotTextMapping: Record<JackpotLevel, JackpotText> = {} as Record<JackpotLevel, JackpotText>;
	public override JackpotLevels(): JackpotLevel[] {
		const levels = Object.keys(this.jackpotTextMapping);
		return levels as JackpotLevel[];
	}


	// public constructor(params: JackpotDisplayParams) {}


	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
	}

	public override Reset(jpLevel: JackpotLevel[]) {
		console.log("Reset JackpotLevel:", jpLevel);
		this.jpValuesSaved.forEach((jp) => {
			let jpCurrentForReset = jpLevel.find((jpReset) => [
				jpReset == jp.JackpotLevel
			])

			if (jpCurrentForReset) {
				console.log("Reset JackpotLevel:", jp.JackpotLevel, "ResetValue:", jp.ResetValue);
				jp.CurrentValue = jp.ResetValue;
				console.log("Current JackpotLevel After Reset:", jp.CurrentValue);
			}
		});

		console.log("JackpotUpdated", this.jpValuesSaved);

		this.InternalUpdate(this.jpValuesSaved);
	}

	public override Resume() {
		this.pauseJackpotValues = false;
		// this.jpValuesSaved.forEach((jp) => {
		// 	console.log("Resume JackpotLevel:", jp.JackpotLevel, "CurrentValue:", jp.CurrentValue);
		// });
		this.UpdateValues(this.jpValuesSaved);
	}

	protected override pauseJackpotValues = false;
	public override Pause() {
		//console.log("Pause JackpotValues");
		this.pauseJackpotValues = true;
	}

	public override InternalUpdate(jackpotValues: JackpotValue2[]): void {

		for (let val of jackpotValues) {
			let jpText = this.jackpotTextMapping[val.JackpotLevel];
			if (jpText == null) {
				// no such text?
				continue;
			}

			jpText.SetTarget(val.CurrentMultipliedValue);
		}

		// //console.log("Jackpot RedraUpdateJackpotValues:",jackpotValues);
		// let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp1);
		// if (jp1 != null) {
		// 	this.jackpotTextMapping[JackpotLevel.Jp1]?.SetTarget(jp1.CurrentMultipliedValue);
		// }

		// let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp2);
		// if (jp2 != null) {
		// 	this.jackpotTextMapping[JackpotLevel.Jp2]?.SetTarget(jp2.CurrentMultipliedValue);
		// }

		// let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp3);
		// if (jp3 != null) {
		// 	this.jackpotTextMapping[JackpotLevel.Jp3]?.SetTarget(jp3.CurrentMultipliedValue);
		// }

		// let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp4);
		// if (jp4 != null) {
		// 	this.jackpotTextMapping[JackpotLevel.Jp4]?.SetTarget(jp4.CurrentMultipliedValue);
		// }			
	}

	protected override jpValuesSaved: JackpotValue2[] = [];
	public override UpdateValues(jackpotValues: JackpotValue2[]): void {
		this.jpValuesSaved = jackpotValues;
		if (this.pauseJackpotValues) {
			//console.log("IsJackpot");
			return
		}
		//inter		
		this.InternalUpdate(this.jpValuesSaved);
	}

	protected logGroup: LogGroup;
	protected resid: ResourceIdentifier = null;

	protected async JPText(): Promise<void> {

		let jp4TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("White"),
			width: Scale.W(frameProps[JackpotLevel.Jp4].textWidth),
			height: Scale.H(frameProps[JackpotLevel.Jp4].textHeight),
			color: "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
			//fontHeight : Scale.fh(300)
		}


		//this.jp4text.View().style.position = "absolute";
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);

		// this.jp4text = new JackpotText(jp4TextParams);
		// this.jp4text.View().classList.add("jp4text");
		// this.jp4text.View().style.left = Scale.Xpx(frameProps[JackpotLevel.Jp4].textX);
		// this.jp4text.View().style.top = Scale.Ypx(frameProps[JackpotLevel.Jp4].textY);
		// this.jp4text.View().style.position = "absolute";


		let jp3TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(frameProps[JackpotLevel.Jp3].textWidth),
			height: Scale.H(frameProps[JackpotLevel.Jp3].textHeight),
			color: "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);

		// this.jp3text = new JackpotText(jp3TextParams);
		// this.jp3text.View().classList.add("jp3text");
		// this.jp3text.View().style.left = Scale.Xpx(frameProps[JackpotLevel.Jp3].textX);
		// this.jp3text.View().style.top = Scale.Ypx(frameProps[JackpotLevel.Jp3].textY);
		// this.jp3text.View().style.position = "absolute";



		let jp2TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(frameProps[JackpotLevel.Jp2].textWidth),
			height: Scale.H(frameProps[JackpotLevel.Jp2].textHeight),
			color: "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);

		// this.jp2text = new JackpotText(jp2TextParams);
		// this.jp2text.View().classList.add("jp2text");
		// this.jp2text.View().style.left = Scale.Xpx(frameProps[JackpotLevel.Jp2].textX);
		// this.jp2text.View().style.top = Scale.Ypx(frameProps[JackpotLevel.Jp2].textY);
		// this.jp2text.View().style.position = "absolute";


		let jp1TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(frameProps[JackpotLevel.Jp1].textWidth),
			height: Scale.H(frameProps[JackpotLevel.Jp1].textHeight),
			color: "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);

		// this.jp1text = new JackpotText(jp1TextParams);
		// this.jp1text.View().classList.add("jp1text");
		// this.jp1text.View().style.left = Scale.Xpx(frameProps[JackpotLevel.Jp1].textX);
		// this.jp1text.View().style.top = Scale.Ypx(frameProps[JackpotLevel.Jp1].textY);
		// this.jp1text.View().style.position = "absolute";

		// this.jp4text.PrepareResources(resourceManager);
		// this.jp3text.PrepareResources(resourceManager);		
		// this.jp2text.PrepareResources(resourceManager);
		// this.jp1text.PrepareResources(resourceManager);
	}
	protected jackpotName: string = null;
	protected async PrepareResourcesGamePreload(resourceManager: IWriteOnlyResourceManager): Promise<void> {


	};

	protected async ResourcesLoadedJackpotLevels(resourceManager: IReadOnlyResourceManager) {

		//ADD VALUE JP4 INTO SPINE
		await this.jackpotTextMapping[JackpotLevel.Jp4]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4]?.Start();

		//ADD VALUE JP3 INTO SPINE
		await this.jackpotTextMapping[JackpotLevel.Jp3]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3]?.Start();

		//ADD VALUE JP2 INTO SPINE
		await this.jackpotTextMapping[JackpotLevel.Jp2]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2]?.Start();

		//ADD VALUE JP1 INTO SPINE
		await this.jackpotTextMapping[JackpotLevel.Jp1]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1]?.Start();

		this.jackpotTextMapping[JackpotLevel.Jp4]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp1]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2]?.Draw();

		this.OnUpdateAppCallback?.();


	}

	protected canvasTextureJP4Value: PIXI.Sprite = null;
	//protected canvasTextureJP4ValueShared: PIXI.Sprite = null;	
	protected canvasTextureJP3Value: PIXI.Sprite = null;
	//protected canvasTextureJP3ValueShared: PIXI.Sprite = null;	
	protected canvasTextureJP2Value: PIXI.Sprite = null;
	protected canvasTextureJP1Value: PIXI.Sprite = null;

	// protected titleSpriteAnim: PIXI.Sprite = null;

	public abstract override TitleHide();
	public abstract override TitleShow();

	public abstract override	StartAnimations(): void;
	public abstract override StopAnimations(): void;
	public abstract override View(): HTMLElement;
	public abstract override Update(): void;

	public override OnResize(): void {
		this.OnResizeCallback?.();
	}

	public OnResizeCallback: ResizeCallback = null;

	public override GetSImgTitleJackpotSpine(): HTMLImageElement {
		return null
	}
	public Destroy() {

	}

	protected jpLevels: string[] = ["jp1", "jp2", "jp3", "jp4"];


	protected jp4Container: PIXI.Container = null;
	protected jp3Container: PIXI.Container = null;
	protected jp2Container: PIXI.Container = null;
	protected jp1Container: PIXI.Container = null;
	protected jpTitleContainer: PIXI.Container = null;

	protected JP4Background: PIXI.Sprite = null;
	protected JP3Background: PIXI.Sprite = null;
	protected JP2Background: PIXI.Sprite = null;
	protected JP1Background: PIXI.Sprite = null;

	protected lastindexAnimInterval: number = -1;
	protected currentRandomAnimationIndex: number = -1;
	protected changeRandomAnimationSpineInterval: IRandomTimeout = null;
	protected animationRanbomTrack: ITrackEntry = null;
	// protected mainJackpotContainer: PIXI.Container = null;


	protected jackpotContainer: ResponsiveSizeContainer = null;
	protected created: boolean = false;

	// protected jackpotFixedContainer: FixedSizeContainer
	// protected biggerJackpotFixedContainer: PIXI.Container
	// protected smallerJackpotFixedContainer: PIXI.Container

	// protected jp4FixedContainer: FixedSizeContainer;
	// protected jp3FixedContainer: FixedSizeContainer;
	// protected jp2FixedContainer: FixedSizeContainer;
	// protected jp1FixedContainer: FixedSizeContainer;
	// protected titleFixedContainer: FixedSizeContainer;

	protected jp4Img: DecodedImageResource;
	protected jp3Img: DecodedImageResource;
	protected jp2Img: DecodedImageResource;
	protected jp1Img: DecodedImageResource;
	protected titleImg: DecodedImageResource;

	protected responsiveView: ResponsiveView;

	protected lastOrientation: Orientation = null;

	protected CreateResponsiveElements() {
		this.responsiveView = new ResponsiveView(window.innerWidth, window.innerHeight, { color: 0x220000, name: 'responsive-view-jackpot' });

		this.jackpotContainer = new ResponsiveSizeContainer(0, 0, 1, 0.13, NaN, { color: 0x550000, secondaryColor: 0x005500, name: 'stats-container-responsive' });
		this.responsiveView.addChild(this.jackpotContainer);
		globalThis.gameViewAppPixiResponsive.GetAppView().stage.addChildAt(this.responsiveView, 0);

	}


	public async Create() {
		await this.CreatejackpotFrames();
		this.CreateResponsiveElements();
		this.CreateJackpotView();
		this.created = true;
		// this.onOrientationChanged(GetOrientation());
		// this.jp4Container = this.app.children.filter(cont => cont instanceof PIXI.Container).find(child => child.name == "jackpot-fixed-container");
		// this.jp3Container = this.app.children.filter(cont => cont instanceof PIXI.Container).find(child => child.name == "jp3-container");
		// this.jp2Container = this.app.children.filter(cont => cont instanceof PIXI.Container).find(child => child.name == "jp2-container");
		// this.jp1Container = this.app.children.filter(cont => cont instanceof PIXI.Container).find(child => child.name == "jp1-container");
	}

	public InternalDestroy() {

		if (!this.created) {
			Log.Debug(this.logGroup, `Destroy() FillingPot: no app, not destroying anything`);
			return;
		}

		if (this.jackpotContainer != null) {
			Safe(() => {
				this.jackpotContainer.destroy({ children: true });
			});
		}

		this.created = false;
		//console.log("Spine-Destroyed",this.resid.ID());
	}

	protected async CreatejackpotFrames() {

		//HERE WE NEED TO CREATE THE FRAMES
	}

	protected CreateJackpotView() { }
	protected jpSpineMap: Map<string, JpAnimationSpine> = new Map<string, JpAnimationSpine>();

	protected CreateIntervalJackpot() {
		if (this.changeRandomAnimationSpineInterval != null) return;
		this.changeRandomAnimationSpineInterval = this.systemContext.TimingContext().CreateRandomTimeout("changeAnimationInterval", 1500, 5000, () => {
			if (this.jpLevels.length > 0) {
				this.lastindexAnimInterval = this.currentRandomAnimationIndex;
				if (this.currentRandomAnimationIndex == this.jpLevels.length - 1) {
					this.jpLevels = shuffle(this.jpLevels);
					//console.log("DoAnotherShuffledAnimation:", this.jpLevels);
				}
				this.currentRandomAnimationIndex = this.jpLevels.randomIndex();
				this.animationRanbomTrack = this.jpSpineMap.get(this.jpLevels[this.currentRandomAnimationIndex]).spine.state.setAnimation(1, this.jpSpineMap.get(this.jpLevels[this.currentRandomAnimationIndex]).animation.random(), false)
				this.changeRandomAnimationSpineInterval.ChangeTimeoutFromTo((this.animationRanbomTrack?.animationEnd * 1000) + 1500, (this.animationRanbomTrack?.animationEnd * 1000) + 5000);
				this.lastindexAnimInterval = this.currentRandomAnimationIndex;
				this.changeRandomAnimationSpineInterval.Start();
			}
		});
		this.changeRandomAnimationSpineInterval.Start();
	}

	public OnUpdateAppCallback: OnUpdateAppCallbackHandler = null;

	public override GetSpineSkeleton(): ISkeletonData {
		return null
	}

	protected ScaleGame(): void {
		this.SetToDefault();

		if (GetOrientation() == Orientation.Landscape) {

			this.jackpotContainer.percentHeight = 0.13;
			this.jackpotContainer.percentWidth = 0.70;
			this.jackpotContainer.percentX = 0;
			this.jackpotContainer.percentY = 0;

			const jackpotNames = ["jp4-container", "jp3-container", "jp2-container", "jp1-container", "title-container"];
			const elements = jackpotNames
				.map(name => this.jackpotContainer.children.find(child => child.name === name) as PIXI.Container)
				.filter(Boolean);

			const count = elements.length;
			if (count === 0) return;

			const availableWidth = this.responsiveView.availableWidth;
			const availableHeight = this.responsiveView.availableHeight * this.jackpotContainer.percentHeight;
			//const maxElementWidth = Math.max(...elements.map(e => e.width));
			const singleGap = Scale.X(30);
			const totalGap = singleGap * (count - 1);

			const elemWidth = (availableWidth * 0.9 - totalGap) / jackpotNames.length;
			//let maxWidthForElements = availableWidth - totalGap;
			//let scale = Math.min(1, maxWidthForElements / (maxElementWidth * count));
			//
			//if (scale > 0.7) scale = 0.7;
			//if (scale < 0.2) scale = 0.2;

			const totalWidth = elements.map(el => {
				const scalex = elemWidth / el.width;
				const scaley = availableHeight / el.height;
				const scale = Math.min(scalex, scaley);

				const scaledWidth = el.width * scale;
				return scaledWidth;
			})
				// sum
				.reduce((a, b) => a + b, 0);

			let currentX = (availableWidth - totalWidth) / 2;
			for (let i = 0; i < elements.length; i++) {
				const el = elements[i];
				// const currentY = (availableHeight - el.height) / 2;

				const scalex = elemWidth / el.width;
				const scaley = availableHeight / el.height;
				const scale = Math.min(scalex, scaley);

				const scaledWidth = el.width * scale;

				//el.width = elemWidth;
				el.scale.set(scale);
				el.position.x = currentX;
				el.position.y = availableHeight / 2 - el.height / 2;
				currentX += scaledWidth;
			}
		} else {

			this.jackpotContainer.percentHeight = 0.15;
			this.jackpotContainer.percentWidth = 0.5;
			this.jackpotContainer.percentX = 0;
			this.jackpotContainer.percentY = 0;

			const elemWidth = this.responsiveView.availableWidth;
			const elemHeight = this.responsiveView.availableHeight * 0.33 / 3;

			{
				const row1Y = 0;

				const row1Width = elemWidth;
				const row1Height = elemHeight * 1.1;

				const jp4width = this.jp4Container.width;
				const scaleX = row1Width / jp4width;
				const scaleY = row1Height / this.jp4Container.height;
				const scale = Math.min(scaleX, scaleY);



				this.jp4Container.scale.set(scale);
				this.jp4Container.position.x = (this.responsiveView.availableWidth - (jp4width * scale)) / 2;
				this.jp4Container.position.y = row1Y;

			}
			{
				const row2Y = elemHeight;

				const row2Width = elemWidth;
				const row2Height = elemHeight * 0.9;

				const jp3width = this.jp3Container.width;
				const scaleX = row2Width / jp3width;
				const scaleY = row2Height / this.jp3Container.height;
				const scale = Math.min(scaleX, scaleY);

				this.jp3Container.scale.set(scale);
				this.jp3Container.position.x = (this.responsiveView.availableWidth - (jp3width * scale)) / 2;
				this.jp3Container.position.y = row2Y;
			}
			{

				const row3Y = elemHeight * 2;

				const row3Width = elemWidth;
				const row3Height = elemHeight;


				const scaleXJp1 = row3Width / 3 / this.jp1Container.width;
				const scaleYJp1 = row3Height / this.jp1Container.height;
				const scaleJp1 = Math.min(scaleXJp1, scaleYJp1);


				this.jp1Container.scale.set(scaleJp1);
				this.jp1Container.position.x = 0;
				this.jp1Container.position.y = row3Y;

				const scaleXTitle = row3Width / 3 / this.jpTitleContainer.width;
				const scaleYTitle = row3Height / this.jpTitleContainer.height;
				const scaleTitle = Math.min(scaleXTitle, scaleYTitle);

				this.jpTitleContainer.scale.set(scaleTitle);
				this.jpTitleContainer.position.x = (this.responsiveView.availableWidth / 3) * 1.5 - this.jpTitleContainer.width / 2;
				this.jpTitleContainer.position.y = row3Y - this.jpTitleContainer.height / 4;

				const scaleXJp2 = row3Width / 3 / this.jp2Container.width;
				const scaleYJp2 = row3Height / this.jp2Container.height;
				const scaleJp2 = Math.min(scaleXJp2, scaleYJp2);

				this.jp2Container.scale.set(scaleJp2);
				this.jp2Container.position.x = this.responsiveView.availableWidth / 3 * 2;
				this.jp2Container.position.y = row3Y;
			}


		}


	}

	protected SetToDefault(): void {
		this.jackpotContainer?.children.forEach((child) => {
			child?.scale.set(1);
			child?.position.set(0, 0);
		})
		this.jackpotContainer.percentHeight = 1;
		this.jackpotContainer.percentWidth = 1;
		this.jackpotContainer.percentX = 0;
		this.jackpotContainer.percentY = 0;

		// this.responsiveView.position.x = 0;
		// this.responsiveView.position.y = 0;

	}

}

export type OnUpdateAppCallbackHandler = () => void;

declare global {
	var jackpotDisplayGlobalResponsive: IJackpotDisplayResponsive
}

export type ResizeCallback = () => void;

